const withoutCountZero = (arr : any[]) => {
  if (!arr || !arr.length) return null;
  return arr.filter((obj) => obj.count !== 0);
};

export default withoutCountZero;
